import { TeamWithDetails } from "../../../types/team.types";
import { Sailboat, Hash, Settings, Zap, Radio, Ship } from "lucide-react";
interface IBoatInfoDisplayProps {
  team: TeamWithDetails;
}
export function BoatInfoDisplay({ team }: IBoatInfoDisplayProps) {
  if (!team.boat) {
    return (
      <p className="text-gray-500 italic">No hay una embarcación registrada.</p>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-2">
      <p className="text-gray-800 flex flex-wrap items-center gap-1">
        <Sailboat className="w-5 h-5 text-gray-600" />
        <span className="font-semibold">Nombre:</span> {team.boat?.name ?? ""}
      </p>
      <p className="text-gray-800 flex flex-wrap items-center gap-1">
        <Hash className="w-5 h-5 text-gray-600" />
        <span className="font-semibold">Matrícula:</span>{" "}
        {team.boat?.registration_number ?? ""}
      </p>
      <p className="text-gray-800 flex flex-wrap items-center gap-1">
        <Settings className="w-5 h-5 text-gray-600" />
        <span className="font-semibold">Marca del motor:</span>{" "}
        {team.boat?.engine_brand ?? ""}
      </p>

      <p className="text-gray-800 flex flex-wrap items-center gap-1">
        <Zap className="w-5 h-5 text-gray-600" />
        <span className="font-semibold">HP del motor:</span>{" "}
        {team.boat?.hp ?? ""}
      </p>
      <p className="text-gray-800 flex flex-wrap items-center gap-1">
        <Radio className="w-5 h-5 text-gray-600" />
        <span className="font-semibold">Radio:</span>{" "}
        {team.boat?.has_radio ? "Sí" : "No"}
      </p>
      <p className="text-gray-800 flex flex-wrap items-center gap-1">
        <Ship className="w-5 h-5 text-gray-600" />
        <span className="font-semibold">Yate:</span>{" "}
        {team.boat?.is_yacht ? "Sí" : "No"}
      </p>
    </div>
  );
}
